import fetchSalon from 'actions/fetchSalon.action';
import postPin from 'actions/pin/postPin.action';
import selectLockEnabled from 'selectors/selectLockEnabled';
import { selectLockToken } from 'selectors/simple';
import logger from 'utils/logger.util';

const L = logger('fetchMissingToken');

let isFetching = false;

const flag = (promise) => {
  isFetching = true;

  promise.then(() => {
    isFetching = false;
  });

  promise.catch((e) => {
    L.warn('flag()', e);
    isFetching = false;
  });

  return promise;
};

const fetchMissingToken =
  ({ salonId, support }) =>
  (dispatch, getState) => {
    if (isFetching) {
      // already in the process of fetching
      return;
    }

    if (!salonId) {
      // can't do anything without the id
      L.warn('Cannot request token, invalid salonId:', salonId);
      return;
    }

    const state = getState();
    const lockEnabled = selectLockEnabled(state);

    // no explicit false means FE doesn't have the necessary info from BE yet
    if (lockEnabled === null) {
      flag(dispatch(fetchSalon(salonId)));
      return;
    }

    if (selectLockToken(state)) {
      // if the token is present, don't try again
      return;
    }

    if (support) {
      // customer support users don't get lock screen, so they must get a token
      flag(dispatch(postPin({ salonId })));
      return;
    }

    if (lockEnabled === true) {
      // every request needs the lock token, but this function is only for the cases that have the pin disabled
      return;
    }

    // lockEnabled is false at this point
    flag(dispatch(postPin({ salonId })));
  };

// noinspection JSUnusedGlobalSymbols
export default fetchMissingToken;
